import PageTitle from '../../../components/shared/PageTitle';
import S01 from './S01';
import S02 from './S02';
import S03 from './S03';
import S04 from './S04';
import S05 from './S05';
import S06 from './S06';
import Outro from '../../../components/product/Outro';

const Barrel = () => {
  return (
    <div>
      <PageTitle title="풀무원 곡물차 하루귀리" subtitle="100% 국내산 통귀리를 우려내 제대로 고소한" />
      <S01 />
      <S02 />
      <S03 />
      <S04 />
      <S05 />
      <S06 />
      <Outro
        title="매일 하루를 하루귀리와 함께 시작하세요!"
        shopUrl="https://brand.naver.com/pulmuonebynature/category/96b3c93dbf444de5ae948580e3210498?cp=1"
        color="brown"
      />
    </div>
  );
};

export default Barrel;
